/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreviewSection/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ImageFile from './ImageFile/index'
import No from './No/index'
import OtherFile from './OtherFile/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PreviewSection({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/Preview/Content/PreviewSection"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let patientDocumentsPreviewFileTypeValueData = fromData.useDataFormat({ viewPath,
context: 'patient_documents',
path: 'preview_file.type',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: patientDocumentsPreviewFileTypeValueData,
})
  return (<React.Fragment
>
<div
  data-testid="PreviewSection.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ImageFile'}>
<ImageFile
  viewPath={`${viewPath}/ImageFile`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherFile'}>
<OtherFile
  viewPath={`${viewPath}/OtherFile`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}